import FactCheckIcon from "@mui/icons-material/FactCheck";
import ListExams from "./List";
import { EXAMS, AdministrationServicePath } from "utils/constants";
import EditExams from "./Edit";
import CreateExams from "./Create";
import ShowExams from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  tenancies: [tenants.MU],
  isMenu: true,
  icon: <FactCheckIcon />,
  name: AdministrationServicePath + EXAMS,
  title: "КСК изпити",
  list: <ListExams />,
  create: <CreateExams />,
  createPermission: permissions.canCreateExams,
  edit: <EditExams />,
  editPermission: permissions.canUpdateExams,
  show: <ShowExams />,
  showPermission: permissions.canPreviewExams,
  permission: permissions.canPreviewExams,
};
